import { renderToString } from 'react-dom/server'
import { parse, format } from "date-fns"

const columns = [
  {
    data: 'created_at',
    width: '20%',
    render: function(data, type, row, meta) {
      if (type === 'display' && data) {
        const date = parse(data, "dd/MM/yyyy HH:mm", new Date())

        const formattedDate = format(date, "do MMM yyyy")
        const formattedTime = format(date, "HH:mm")

        return renderToString(
          <div>
            <span className="purple-80 bold">{formattedDate}</span><br />
            <span className="purple-60">at {formattedTime}</span>
          </div>
        )
      }
      return data
    }
  },
  {
    data: 'content',
    width: '50%',
    render: function(data, type, row, meta) {return renderToString(<div>{data}</div>)}
  },
  {
    data: 'created_by',
    width: '25%',
    className: 'light',
    searchable: false,
    orderable: false,
  },
  {
    data: 'id',
    width: '5%',
    className: 'right',
    render: function(data, type, row, meta) {
      const canEdit = window.ENV['CURRENT_USER_PERMISSIONS'].includes('manage_client_admin') || window.ENV['USER_ID'] == row.user_id
      if (canEdit) {
        return renderToString(
          <button
            className="button small secondary edit-target-note-button"
            type="button"
            data-note-id={data}
          >
            Edit
          </button>
        )
      }
      return ''
    },
  },
]

const headers = ['Date Created', 'Note', 'Created By', '']

const filters = []

const sorters = [
  { column: 0, label: 'Date Created', order: 'desc' }
]

const order = [[0, 'desc']]

export { columns, headers, filters, sorters, order }
